"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
const constants_1 = require("utils/constants");
const store_1 = require("store");
const input_1 = require("components/atoms/input");
const react_redux_1 = require("react-redux");
const user_role_action_1 = __importDefault(require("../../user-role.action"));
const kendo_data_query_1 = require("@progress/kendo-data-query");
const GridComponent = (_a) => {
    var { dataGrid, dataStates, style, onPageChange, onFilterChange, pageable } = _a, props = __rest(_a, ["dataGrid", "dataStates", "style", "onPageChange", "onFilterChange", "pageable"]);
    const { dataGridRoleMapping, dataItem, mutationMode, dataMobileWeb } = (0, store_1.useAppSelector)(state => state.userAccess.userRoleReducer);
    const [rowheight, setRowHeight] = (0, react_1.useState)(20);
    const initialFilter = { logic: 'and', filters: [] };
    const initialSort = [{ field: 'submodule', dir: 'asc', },];
    const [filter, setFilter] = (0, react_1.useState)(initialFilter);
    const [sort, setSort] = (0, react_1.useState)(initialSort);
    const dispatch = (0, react_redux_1.useDispatch)();
    console.log(onFilterChange, onPageChange, pageable);
    (0, react_1.useEffect)(() => {
        const [gridElement] = document.getElementsByClassName('k-widget k-grid no-scrollbar');
        if (gridElement) {
            const containerHeight = gridElement.clientHeight;
            const height = containerHeight / (dataGrid.length + 3);
            setRowHeight(height < 30 ? undefined : height);
        }
    }, [dataGrid]);
    const onChange = (arg) => {
        const apps_type = arg.field.split('_')[0];
        const view_change = arg.field.split('_')[1];
        const existingData = dataItem.authorization.find(i => i.menu_id == arg.id);
        let newDataItem = dataItem;
        if (existingData === null || existingData === void 0 ? void 0 : existingData.menu_id) {
            const arrAuth = newDataItem.authorization;
            newDataItem = Object.assign(Object.assign({}, dataItem), { 'authorization': [
                    ...arrAuth.filter(i => i.menu_id != existingData.menu_id),
                    {
                        menu_id: existingData.menu_id,
                        id: arg.id || existingData.id,
                        module: '',
                        submodule: '',
                        apps_type: apps_type,
                        view: view_change == 'view' ? !existingData.view : existingData.view,
                        change: view_change == 'change' ? !existingData.change : existingData.change,
                    }
                ] });
        }
        else {
            newDataItem = Object.assign(Object.assign({}, dataItem), { 'authorization': [
                    ...dataItem.authorization,
                    {
                        menu_id: arg.id || '',
                        id: arg.id || '',
                        module: '',
                        submodule: '',
                        apps_type: apps_type,
                        view: view_change == 'view',
                        change: view_change == 'change',
                    }
                ] });
        }
        dispatch(user_role_action_1.default.onClickMutation({ mutationMode, dataItem: newDataItem, isSuccess: false }));
    };
    const CustomCell = (props) => {
        var _a, _b, _c, _d, _e;
        const dataSelected = dataItem.authorization.find(i => props.dataItem.id == i.menu_id);
        const dataMenu = dataGridRoleMapping.find(i => i.id === props.dataItem.id);
        if ((_a = props === null || props === void 0 ? void 0 : props.field) === null || _a === void 0 ? void 0 : _a.includes(props.dataItem.apps_type)) {
            return (((0, jsx_runtime_1.jsx)("td", Object.assign({ style: { 'textAlign': 'center' } }, { children: (0, jsx_runtime_1.jsx)(input_1.Input, { id: dataMenu === null || dataMenu === void 0 ? void 0 : dataMenu.id, type: 'checkbox', style: { 'height': 18 }, onChange: e => onChange({
                        field: (props === null || props === void 0 ? void 0 : props.field) || '',
                        value: e.target.value,
                        id: dataMenu === null || dataMenu === void 0 ? void 0 : dataMenu.id,
                        dataMenu
                    }), checked: ((_b = props.field) === null || _b === void 0 ? void 0 : _b.includes('view')) || '' ? dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.view : (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.change) &&
                        ((_c = props.field) === null || _c === void 0 ? void 0 : _c.includes(dataSelected.apps_type)) &&
                        (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.menu_id) == (dataMenu === null || dataMenu === void 0 ? void 0 : dataMenu.id) }) }))));
        }
        else if (dataMenu === null || dataMenu === void 0 ? void 0 : dataMenu.subId) {
            const dataSelectedSub = dataItem.authorization.find(i => props.dataItem.subId == i.menu_id);
            const dataMenuSub = dataMobileWeb.find(i => i.id === props.dataItem.subId);
            return (((0, jsx_runtime_1.jsx)("td", Object.assign({ style: { 'textAlign': 'center' } }, { children: (0, jsx_runtime_1.jsx)(input_1.Input, { id: dataMenu === null || dataMenu === void 0 ? void 0 : dataMenu.subId, type: 'checkbox', style: { 'height': 18 }, onChange: e => onChange({
                        field: (props === null || props === void 0 ? void 0 : props.field) || '',
                        value: e.target.value,
                        id: dataMenu.subId,
                        dataMenu
                    }), checked: ((_d = props.field) === null || _d === void 0 ? void 0 : _d.includes('view')) || '' ? dataSelectedSub === null || dataSelectedSub === void 0 ? void 0 : dataSelectedSub.view : (dataSelectedSub === null || dataSelectedSub === void 0 ? void 0 : dataSelectedSub.change) &&
                        ((_e = props.field) === null || _e === void 0 ? void 0 : _e.includes(dataSelectedSub.apps_type)) &&
                        (dataSelectedSub === null || dataSelectedSub === void 0 ? void 0 : dataSelectedSub.menu_id) == (dataMenuSub === null || dataMenuSub === void 0 ? void 0 : dataMenuSub.id) }) }))));
        }
        else {
            return (((0, jsx_runtime_1.jsx)("td", Object.assign({ style: { 'textAlign': 'center' } }, { children: (0, jsx_runtime_1.jsx)("span", { children: "N/A" }) }))));
        }
    };
    const CustomHeader = (props) => {
        return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ style: {
                textAlign: 'center'
            } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ style: {
                        textAlign: 'center',
                        display: 'block'
                    } }, { children: props.title })), props.children] })));
    };
    return ((0, jsx_runtime_1.jsxs)(kendo_react_grid_1.Grid, Object.assign({ sortable: true, filterable: true, sort: sort, filter: filter, style: style, take: 1000, pageSize: 1000, editField: 'inEdit', className: 'no-scrollbar', rowHeight: rowheight, filterOperators: constants_1.customFilterOperator, scrollable: dataStates.scrollable, total: dataGridRoleMapping.length, onSortChange: (e) => setSort(e.sort), onFilterChange: (e) => setFilter(e.filter), data: (0, kendo_data_query_1.filterBy)(dataGridRoleMapping, filter) }, props, { children: [(0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { headerCell: CustomHeader, field: 'module', title: 'Module', sortable: true }), (0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { headerCell: CustomHeader, field: 'submodule', title: 'Sub Module', sortable: true }), (0, jsx_runtime_1.jsxs)(kendo_react_grid_1.GridColumn, Object.assign({ headerCell: CustomHeader, title: 'Mobile', field: 'mobile' }, { children: [(0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { headerCell: CustomHeader, field: 'Mobile_view', width: 100, title: 'View', filter: 'boolean', cell: CustomCell }), (0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { headerCell: CustomHeader, field: 'Mobile_change', width: 100, title: 'Change', filter: 'boolean', cell: CustomCell })] })), (0, jsx_runtime_1.jsxs)(kendo_react_grid_1.GridColumn, Object.assign({ headerCell: CustomHeader, title: 'Web', field: 'web' }, { children: [(0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { headerCell: CustomHeader, field: 'Web_view', width: 100, title: 'View', filter: 'boolean', cell: CustomCell }), (0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, { headerCell: CustomHeader, field: 'Web_change', width: 100, title: 'Change', filter: 'boolean', cell: CustomCell })] }))] })));
};
exports.default = GridComponent;
